<div
    *ngIf="watchlist !== undefined"
    class="flex flex-col justify-between h-full rounded-md border border-[#91AFF4] p-4 shadow-[2px_2px_3px_0px_#0045E670]"
>
    <h3 class="self-center font-extrabold uppercase"
    [ngClass]="watchlist.length > 0 && 'text-[#0045E6]'"
        >ma watchlist</h3
    >

    <ng-container *ngIf="watchlist.length === 0">
        <button
            (click)="openWatchlist()"
            class="mt-7 flex items-center justify-center gap-1 self-center rounded-full bg-[#0045E6] p-2 text-white font-bold text-sm"
        >
            <mat-icon
                class="icon-size-4"
                svgIcon="feather:plus"
            />
            Ajouter Maintenant
        </button>
        <span class="mt-7 text-center text-xs"
            >Surveiller mes valeurs préférées</span
        >
    </ng-container>
    <ng-container *ngIf="watchlist.length > 0">
        <div class="p-1 h-36">
            <a
                *ngFor="let data of watchlist[page]"
                (click)="reloadPage(data?.referentiel?.stockName,data?.referentiel?.isin)"
                class="flex items-center justify-between justify-self-stretch border-b border-dotted border-[#adadad] py-1 last:border-none"
            >
                <span class="text-sm hover:underline">{{ data?.referentiel?.ticker }}</span>
                <div class="flex flex-col items-end">
                    <span class="text-xs text-black">{{
                        data?.last | number: '.2-2'
                    }}</span>
                    <span
                        class="text-sm"
                        [ngClass]="{
                            'text-[#E70013]': data?.change < 0,
                            'text-[#7DAF66]': data?.change >= 0,
                        }"
                    >
                        <mat-icon
                            class="icon-size-3"
                            [ngClass]="{
                                'text-[#E70013]': data?.change < 0,
                                'text-[#7DAF66]': data?.change >= 0,
                            }"
                            [svgIcon]="
                                data?.change >= 0
                                    ? 'heroicons_solid:arrow-small-up'
                                    : 'heroicons_solid:arrow-small-down'
                            "
                        />
                        {{ data?.change | abs | number: '.2-2' }}%</span
                    >
                </div>
            </a>
        </div>
        <div class="flex items-center justify-between">
            <button
                class="flex gap-1 text-sm font-semibold text-[#0045E6]"
                (click)="openWatchlist()"
            >
                <mat-icon class="icon-size-4" svgIcon="feather:plus-circle" />
                <span class="hidden lg:inline">Ajouter</span>
            </button>
            <div class="flex items-center gap-2 text-sm">
                <span
                    >{{ page * pageLength + 1 }} -
                    {{ page * pageLength + watchlist[page].length }} sur
                    {{
                        (watchlist.length - 1) * pageLength +
                            watchlist[watchlist.length - 1].length
                    }}</span
                >
                <div>
                    <button
                        class="text-[#0045E6] icon-size-5 disabled:text-gray-300"
                        [disabled]="this.page === 0"
                        (click)="lastPage()"
                    >
                        <mat-icon svgIcon="heroicons_solid:arrow-left-circle" />
                    </button>
                    <button
                        class="text-[#0045E6] icon-size-5 disabled:text-gray-300"
                        [disabled]="this.page === this.watchlist.length - 1"
                        (click)="nextPage()"
                    >
                        <mat-icon
                            svgIcon="heroicons_solid:arrow-right-circle"
                        />
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</div>
